import { CONFIG } from './settings'
import { RECOIL_KEYS } from './recoilKeys'
import { selector } from 'recoil';
import { rc_menu_list } from './atom'


const api_menu_list = selector({
  key: 'selector_'+RECOIL_KEYS.MENU_LIST,

  get: async ({get})=>{
    const curValue = get(rc_menu_list)

    if (Array.isArray(curValue) && curValue.length > 0) {
      return curValue
    } else {
      try {
        const response = await fetch(CONFIG.API.GROUPS)
        
        if (!response.ok) {
          console.warn('メニューリストのHTTPエラー:', response.status, response.statusText);
          return [];
        }
        
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          console.warn('メニューリストのContent-Typeエラー:', contentType);
          return [];
        }
        
        return await response.json()
      } catch(e) {
        console.warn('メニューリストの取得エラー:', e);
        return []
      }
    }
  },

  set: ({set, get}, newValue)=>{
    // TODO: 同一オブジェクトの場合setしない
    //if (newValue == get(rc_menu_list)) {
    //  //return newValue
    //} else {
    //  set(rc_menu_list, newValue)
    //}

    set(rc_menu_list, newValue)
  }
})


export { api_menu_list }
